import React from 'react';
import MobilityIcon from '../../images/mobility.svg';
import InvestmentIcon from '../../images/investment.svg';
import QualityIcon from '../../images/quality.svg';

export const MobilityIndex = {
	title: 'Mobility index',
	description:
		'The Enhanced Mobility Index is the first of the three dimensions of the Global Passport Index and the one carrying the most weight, responsible for 50% of the composite score.',
	countries: [],
	link: '/enhanced-mobility-index/',
	IconComponent: () => <img src={MobilityIcon} className="rankings__icon" />,
};
export const InvestmentIndex = {
	title: 'Investment index',
	description:
		'The Economy Index, aims to provide a general assessment of an economy as an option for investment and other business decisions.',
	countries: [],
	link: '/investment-index/',
	IconComponent: () => (
		<img src={InvestmentIcon} className="rankings__icon" />
	),
};
export const QualityIndex = {
	title: 'Quality of life index',
	description:
		'Assessing the availability and cost of day-to-day amenities such as infrastructure, cost of living, personal and political freedom, environmental quality and attitudes towards foreigners.',
	countries: [],
	link: '/quality-of-life-index/',
	IconComponent: () => <img src={QualityIcon} className="rankings__icon" />,
};
